import { Box, styled } from "@mui/material";

export const FilenameContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  position: "absolute",
  padding: theme.spacing(0.5),
  maxWidth: "50%",
  zIndex: 5,
  backgroundColor: "rgba(242, 242, 242, 0.4)",
  top: 0,
  left: 0,
}));
